export const environment = {
  production: false,
  apiUrl: 'https://dev-sales.theo2uk.service.3ddigitalvenue.com/api/v1/',
};
